export { App } from './app'
export type { TGtmConfig, TPageProps } from './types'
